import {
  Box,
  Drawer,
  LinearProgress,
  Toolbar,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useCallback, useState, type ReactNode } from "react";
import { Helmet } from "react-helmet-async";
import { MainMenu } from "./mainmenu/MainMenu";
import Nav from "./Nav";
import SuspenseBoundary from "./SuspenseBoundary";
import {layoutStyles} from "../styles/layout.styles";

export default function Layout({
  title,
  path,
  back,
  children,
}: {
  title?: ReactNode;
  path?: Array<string>;
  back?: string;
  children: ReactNode;
}) {
  const theme = useTheme();
  const mobile = !useMediaQuery(
    `(min-width: ${theme.breakpoints.values.md}px)`
  );
  const [open, setOpen] = useState(false);
  const close = useCallback(() => setOpen(false), []);
  const pageTitle = (path ?? (typeof title === "string" ? [title] : []))
    .toReversed()
    .join(" · ");

  return (
    <>
      <Helmet title={pageTitle} titleTemplate="%s · Guude AI">
        <meta name="theme-color" content={theme.palette.primary.dark} />
      </Helmet>
      <Box sx={layoutStyles.layout.outerBoxContainer}>
        <Drawer
          variant={mobile ? "temporary" : "permanent"}
          open={mobile && open}
          onClose={close}
          PaperProps={{ sx: layoutStyles.layout.drawerPaper}}
          sx={layoutStyles.layout.drawer}
        >
          <MainMenu close={close} />
        </Drawer>
        <Box sx={layoutStyles.layout.innerBoxContainer}>
          <Nav
            title={title}
            back={back}
            mobile={mobile}
            open={open}
            setOpen={setOpen}
          />
          <Toolbar />
          <SuspenseBoundary fallback={<LinearProgress />}>
            <Box component="main" sx={layoutStyles.layout.suspenseBoundaryBoxContainer}>
              {children}
            </Box>
          </SuspenseBoundary>
        </Box>
      </Box>
    </>
  );
}
